import React from 'react';
import TextField from '@material-ui/core/TextField';

export function SearchFilter({ filterKey, filterValue, fullWidth = false, label, onChange, id }) {
  function handleChange(event) {
    onChange(filterKey, event.target.value.toLowerCase());
  }

  return <TextField onChange={handleChange} value={filterValue} fullWidth={fullWidth} placeholder={label} id={id} />;
}
